import React, { PureComponent } from "react";
import { connectStore } from "redux-box";
import { module as pronunciationLexicon } from "@st/pronunciationLexicon";
import { SearchBarContainer } from "@c/users-view/MainContent.styled";
import {
  NavigationContainer,
  NavigationHeaderContainer,
  NavigationToolbar,
} from "@sc/NavigationBar.styled";
import { PronunciationTitle } from "../PronunciationView.styled";

const SEARCH_DEBOUNCE = 1000;

class PronunciationHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      search: props.pronunciationLexicon.search,
      voice: props.pronunciationLexicon.voice_filter,
      searchBarEnable: false,
    };
    this.searchTimer = null;
  }

  componentWillUnmount() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }

  enableSearchBar = actionType => {
    if (actionType === "focus" && !this.state.searchBarEnable)
      this.setState({ searchBarEnable: true });
    else if (actionType === "blur" && this.state.searchBarEnable)
      this.setState({ searchBarEnable: false });
  };

  handleSearchChange = e => {
    const search = e.target.value;
    this.setState({ search });
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.props.pronunciationLexicon.setSearch(search);
    }, SEARCH_DEBOUNCE);
  };

  handleVoiceChange = e => {
    const voice = e.target.value;
    this.setState({ voice });
    this.props.pronunciationLexicon.setVoiceFilter(voice);
  };

  handleClearSearch = () => {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.setState({ search: "" });
    this.props.pronunciationLexicon.setSearch("");
  };

  render() {
    const { search, voice, searchBarEnable } = this.state;
    const { voices } = this.props.pronunciationLexicon;

    return (
      <NavigationHeaderContainer>
        <NavigationContainer>
          <PronunciationTitle>Pronunciation Dictionary</PronunciationTitle>
        </NavigationContainer>

        <NavigationToolbar>
          <div className="input-group mx-2 my-1" style={{ width: "fit-content" }}>
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="pronunciationVoiceFilter">
                Voice
              </label>
            </div>
            <select
              className="custom-select"
              id="pronunciationVoiceFilter"
              value={voice}
              onChange={this.handleVoiceChange}
            >
              <option value="">All voices</option>
              {voices.map(v => (
                <option key={v.key} value={v.key}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>

          <SearchBarContainer width={searchBarEnable ? "300px" : "200px"}>
            <i className="fa fa-search" />
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={this.handleSearchChange}
              onFocus={() => this.enableSearchBar("focus")}
              onBlur={() => this.enableSearchBar("blur")}
            />
            {search ? (
              <i
                className="fa fa-times cross"
                onClick={this.handleClearSearch}
              />
            ) : null}
          </SearchBarContainer>
        </NavigationToolbar>
      </NavigationHeaderContainer>
    );
  }
}

export default connectStore({ pronunciationLexicon })(PronunciationHeader);
